export const ANIMATION_NAMES = {
	walk: 'Walk_anim_Armature',
	idle: 'Idle_anim_Armature',
	wave: 'Wave_anim_Armature',
	jump: 'Jump_anim_Armature',
	talk: 'Talk_anim_Armature',
};

export const COLLIDABLE_MESH_NAME = 'collision_mesh';

export const DEFAULT_GRAVITY = -0.1;

export const DEFAULT_WALK_VELOCITY = 6;
export const DIRECTIONS = [
	'w',
	'a',
	's',
	'd',
	'arrowup',
	'arrowleft',
	'arrowdown',
	'arrowright',
];
export const VISUALIZE_COLLIDERS = false;

export const MAXIMUM_MULTIPLIER = 0.02;

export const DEFAULT_AVATAR_MIN_DISTANCE_FROM_CAMERA = 3;
export const DEFAULT_AVATAR_MAX_DISTANCE_FROM_CAMERA = 4;

export const DEFAULT_FPS_MIN_DISTANCE_FROM_CAMERA = 0.1;
export const DEFAULT_FPS_MAX_DISTANCE_FROM_CAMERA = 0.2;

export const DEFAULT_AVATAR_CAMERA_Y_OFFSET = 4;
export const DEFAULT_FPS_CAMERA_Y_OFFSET = 1.3;

export const AVATAR_COLLIDER_THRESHOLD_MIN = 0.1;
export const AVATAR_COLLIDER_THRESHOLD_MAX = 20;

